<template>
  <div v-loading="loading" class="fddform-table">
    <div class="fddform-theader" :style="`padding-right: ${scrollerWidth}px`">
      <table cellpadding="0" cellspacing="0">
        <tr>
          <th v-for="col in cols" :key="col.prop || col.type" :width="col.width" :class="col.headerClass">
            <!-- 全选 -->
            <label v-if="col.type === 'checkbox'" :class="'fdd-radio' + (isAllSelect ? '-on' : '')" @click="toggleAll">
              <span class="use-icon_radio"></span>
            </label>

            <!-- header slot -->
            <slot v-if="$scopedSlots['header:' + col.prop]" :name="'header:' + col.prop" v-bind="{ col, index }">
              {{ col.label }}
            </slot>

            <template v-else>
              {{ col.label }}
              <div v-if="col.sortable" class="arrow">
                <a
                  :class="['use-PC_up', { hover: defaultSort.prop === col.prop && defaultSort.order === 'asc' }]"
                  @click="sortClick(col.prop, 'asc')"
                />
                <a
                  :class="['use-PC_down', { hover: defaultSort.prop === col.prop && defaultSort.order === 'desc' }]"
                  @click="sortClick(col.prop, 'desc')"
                />
              </div>
            </template>

            <!-- 过滤列表 -->
            <template v-if="col.filters && col.filters.length">
              <i
                class="sign-icon-filter"
                :class="{ cur: filters[col.prop] !== undefined }"
                @click.stop="filterPop = col.prop"
              ></i>
              <!--点击筛选按钮，出现下拉-->
              <ul v-if="filterPop === col.prop" class="com-down-list wid-100">
                <li @click="filter(col.prop)">全部</li>
                <li
                  v-for="(item, index) in col.filters"
                  :key="index"
                  :class="{ cur: filters[col.prop] === item.value }"
                  @click="filter(col.prop, item.value)"
                >
                  {{ item.text || item.value }}
                </li>
              </ul>
            </template>
          </th>
        </tr>
      </table>
    </div>

    <div class="fddform-tbody">
      <no-data v-if="!loading && !rows.length" :message="queryError || emptyText">
        <slot name="empty"></slot>
      </no-data>

      <table v-else ref="tbody" cellpadding="0" cellspacing="0">
        <template v-for="(row, index) in rows">
          <table-row :key="getRowId(row)" :row="row" :index="index" />
          <tr v-if="expandId === getRowId(row)" :key="'expand' + getRowId(row)">
            <td :colspan="cols.length">
              <table-render v-if="expand" :render="expand" v-bind="{ row, index }" />
              <slot v-else name="expand" v-bind="{ row, index }" />
            </td>
          </tr>
        </template>
      </table>
    </div>

    <!-- 分页组件 -->
    <page v-if="pager" v-bind="pager" :paged="paging" />
  </div>
</template>

<script>
  import Table from './Table.js'
  export default Table
</script>

<style lang="less" scoped>
  .fddform-table {
    position: relative;
    overflow: hidden;
    line-height: 1.2;

    .fdd-page {
      margin: 0;
      padding: 0;
      padding-top: 20px;
    }
  }

  .highlighted {
    background: #ecf5ff;
  }
</style>
